<style src="./Main.scss" lang="scss" scoped></style>
<template>
  <WrongBrowser v-if="isWrongBrowser" 
    :browser-version="browserVersion"
    :browser-name="browserName"
  />

  <section v-else class="home">
    <main class="login-container">
      <div class="login-container__form" @keydown="handleEnterKey">
        <img v-if="logo" :src="logo" class="imag-logo" />
        <div v-else>
          <h1 class="title">Bem-vindo(a)</h1>
          <h1 class="title">à <span class="two">TeleConsulta</span></h1>
        </div>
        <h2 class="title-two">Digite o seu login para entrar</h2>
        <InputText
          label="CPF"
          placeholder="Digite aqui o seu CPF"
          mask="###.###.###-##"
          v-model="inputCpf"
        />
        <InputPassword label="Senha" placeholder="Digite aqui a sua senha" v-model="inputPsw" />
        <div class="label-link" @click="gotoForgetPassword">
          Esqueceu a senha?
        </div>
        <footer class="act">
          <span class="msgErro">{{ msgErro }}</span>
          <div class="btn" @click="actLogin" >Entrar</div>
          <div class="btn clean" @click="gotoChangeToRegister">
            Cadastrar Nova Conta
          </div>
          <div class="version">Versão {{ appVersion }}</div>
        </footer>
      </div>
      <aside>
        <Carousel />
      </aside>
    </main>

    <ModalRoot :open="showModalRoomCall" big>
      <ModalMain>
        <section class="modal-room-call">
          <div class="title">O seu médico está ligando para você</div>
          <div class="text">
            Nesse momento não será possível entrar na
            teleconsulta. Aceite a chamada do seu 
            profissional através do Aplicativo Tele Qualitá.
          </div>
          <div class="btn" @click="showModalRoomCall = false">Confirmar</div>
        </section>
      </ModalMain>
    </ModalRoot>
    
    <ModalRoot :open="showModalResetPassword" big>
      <ModalMain>
        <section class="reset-password">
          <div class="title">Redefinir <span class="light">Senha</span></div>
          <InputPassword
            label="Nova senha"
            placeholder="Digite aqui a sua nova senha"
            v-model="newPassword"
          />
          <section class="password-description">
            <span class="label">A senha deve possuir:</span>
            <div class="fields">
              <section class="item">
                <span class="ball" :class="{ on: checkPsw.caracter }"/>
                <span class="text">8 caracteres.</span>
              </section>
              <section class="item">
                <span class="ball" :class="{ on: checkPsw.min }"/>
                <span class="text">1 letra minúscula.</span>
              </section>
              <section class="item">
                <span class="ball" :class="{ on: checkPsw.special }"/>
                <span class="text">1 caracter especial.</span>
              </section>
              <section class="item">
                <span class="ball" :class="{ on: checkPsw.num }"/>
                <span class="text">1 número.</span>
              </section>
              <section class="item">
                <span class="ball" :class="{ on: checkPsw.max }"/>
                <span class="text">1 letra maiúscula.</span>
              </section>
            </div>
          </section>
          <div class="msgErro">{{ msgErro }}</div>
          <div class="btn" @click="actNewPsw">Redefinir senha</div>
          <div class="btn clean" @click="showModalResetPassword = false">Voltar</div>
        </section>
      </ModalMain>
    </ModalRoot>

    <ModalRoot :open="showModalLgpd" big>
      <ModalMain>
        <section class="lgpd-content">
          <PrivacyPolicy />
          <div class="__acts">
            <label>
              <input type="checkbox" v-model="isCheckedLgpd" />Eu aceito e concordo com os Termos e Condições<sup class="required">*</sup>
            </label>
            <small class="required" v-show="showRequiredTermsLicenceMessage">Para prosseguir é necessário dar o aceite nos termos e condições</small>
          </div>
          <div class="lgpd__actions">
            <button class="btn cancel" @click="gotoChangeToLogin">Cancelar</button>
            <button class="btn" @click="onClickConfirmLgpd">Confirmar</button>
          </div>
        </section>
      </ModalMain>
    </ModalRoot>
  </section>
</template>

<script>
import packageInfo from '../../../../package.json'
import moment from 'moment'
import ConfigDeveloper from "@/ConfigDeveloper.js"
import ApiService from "./services/ApiService";
import FirebaseService from "./services/FirebaseService";

import InputText from "@/components/input/text/InputText";
import InputPassword from "@/components/input/password/InputPassword";
import Carousel from "./components/Carousel";
import IconWrongBrowser from "./components/IconWrongBrowser";
import IconAppStore from "./components/IconAppStore";
import IconPlayStore from "./components/IconPlayStore";

import CabineVideo from "@/views/patient/video/CabineVideo";
import WrongBrowser from "@/views/patient/main/components/wrong-browser/WrongBrowser.vue";
import ModalRoot from "@/components/modal/ModalRoot.vue";
import ModalMain from "@/components/modal/ModalMain.vue";

import PrivacyPolicy from '@/privacyPolicy'

export default {
  name: "PortalPatientMain",
  components: {
    ModalMain,
    ModalRoot,
    WrongBrowser,
    InputText,
    CabineVideo,
    InputPassword,
    Carousel,
    IconWrongBrowser,
    IconAppStore,
    IconPlayStore,
    PrivacyPolicy
  },

  data() {
    return {
      isWrongBrowser: false,
      showModalLgpd: false,
      showModalResetPassword: false,
      showModalRoomCall: false,

      usu_id: null,
      inputCpf: '',
      inputPsw: '',
      newPassword: '',
      pacNome: '',
      firebaseToken: null,

      ApiService: null,
      FirebaseService: null,
      ConfigDeveloper: null,

      didntClickLgpdCheck: false,
      msgErro: null,
      pdfSrc: null,
      isCheckedLgpd: false,
      browserVersion: "",
      browserName: "",
      runningEnterRoom: false,
      permissionCamera: false,
      permissionMicrophone: false,
      showRequiredTermsLicenceMessage: false,
      helperMessage: (type) => ` Por favor, habilite a permissão no seu navegador e recarregue a página.

🔒 Como fazer isso?
Clique nos ajustes ao lado do endereço do site no seu navegador.
  1- Vá até Permissões > ${type} e selecione Permitir.
  2- Atualize a página.`,
      checkPsw: {
        caracter: false,
        min: false,
        special: false,
        num: false,
        max: false,
      },
    };
  },

  computed: {
    logo() {
      return process.env.VUE_APP_LOGO || null
    }
  },

  watch: {
    "newPassword"(val) {
      this.validateCheckPassword(val);
    },
  },

  async beforeMount() {
    this.ConfigDeveloper = new ConfigDeveloper()
    setTimeout(() => {
      document.title = "Portal de Teleconsulta";
      this.pdfSrc = process.env.VUE_APP_LINK_PDF_LGPD;
    }, 500);
  },

  async mounted() {
    this.getBrowserInfo();

    this.ApiService = new ApiService();
    this.FirebaseService = new FirebaseService();

    await this.checkMediaPermissionsCamera();
    await this.checkMediaPermissionsMicrophone();

    const devForm = this.ConfigDeveloper.getFormLogin()
    if (devForm) {
      this.inputCpf = devForm.cpf
      this.inputPsw = devForm.password
    }

    this.checkQueryStringAndReload()
  },


  computed: {
    appVersion() {
      return packageInfo.version || '';
    }
  },

  methods: {
    async checkQueryStringAndReload() {
      if (this.$route.query.reload === 'true') {
        setTimeout(() => {
          this.$router.replace({ query: { ...this.$route.query, reload: "false" } }).then(() => {
            window.location.reload();
          });
        }, 250)
      }
    },

    /**
     * Detecta a tecla "Enter" e chama o método `actLogin` se pressionada.
     * @param {KeyboardEvent} event - O evento de teclado que foi disparado.
     */
    handleEnterKey(event) {
      if (event.key === "Enter") {
        this.actLogin();
      }
    },

    /**
     * Altera o estado para exibir o formulário de esqueci a senha.
     */
    gotoForgetPassword() {
      // alert('partiu trocar senha')
      try {
        this.$router.push({ path: "/forgot-password" });
      } catch (err) {
        alert(err)
      }
    },

    /**
     * Altera o estado para exibir o formulário de registro.
     */
    gotoChangeToRegister() {
      this.$router.push({ path: "/register" });
    },
    
    /**
     * Altera o estado para exibir o formulário de login.
     */
    gotoChangeToLogin() {
      this.inputCpf = '';
      this.inputPsw = '';
      this.msgErro = null;
      this.showModalLgpd = false;
      this.showRequiredTermsLicenceMessage = false;
    },
    
    /**
     * Abre a sala se o CPF e a senha forem válidos.
     * Muda a tela para a visualização de vídeo se a validação for bem-sucedida.
     * @async
     */
    async actLogin() {
      if (this.runningEnterRoom) {
        return
      }
      this.runningEnterRoom = true

      this.msgErro = null;
      setTimeout(async () => {
        if (!this.inputCpf) {
          this.runningEnterRoom = false
          return
        }

        this.showModalRoomCall = false

        const cpfFormat = this.inputCpf.replace(/[.-]/g, "");
        const objLoginUser = await this.ApiService.loginCabine({
          cpf: cpfFormat,
          psw: this.inputPsw,
        });
        const loginUser = objLoginUser.length > 0 ? objLoginUser[0] : null
        this.newPassword = ''
        if (loginUser) {
          this.pacNome = loginUser.usu_nome_usuario
          this.usu_id = loginUser.usu_id;
          this.firebaseToken = loginUser.firebaseToken;
          if (loginUser.usu_aceite_lgpd_cabine === 0) {
            this.showModalLgpd = true;
            this.showModalResetPassword = false
            this.runningEnterRoom = false
            return;
          }
          if (loginUser.usu_senha_temporaria_ativa === 1) {
            this.showModalLgpd = false;
            this.showModalResetPassword = true
            this.runningEnterRoom = false
            return;
          }
          this.runningEnterRoom = false

          const payloadLog = {
            type: 'INSERT',
            cpf: cpfFormat || 'Não informado',
            origem: 'Portal Paciente SUS',
            pacNome: loginUser.usu_nome_usuario || 'Não informado',
            payload: JSON.stringify({ browserName: this.browserName, browserVersion: this.browserVersion }),
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            subtype: `Navegador ${this.browserName}. V.${this.browserVersion}`
          }
          this.ApiService.saveTeleconsultMovimentLog(payloadLog)

          this.gotoVideo();
        } else {
          this.msgErro = `CPF ou Senha incorretos`;
          this.runningEnterRoom = false
        }
      }, 100);
    },

    /**
     * Função que confirma a aceitação da LGPD e salva essa informação.
     * @async
     */
    async onClickConfirmLgpd() {
      this.showRequiredTermsLicenceMessage = false;
      if (!this.isCheckedLgpd) {
        this.showRequiredTermsLicenceMessage = true;
        this.$toast.open({
            message: 'Aceite os termos e condições para continuar.',
            type: 'error',
          });
        return;
      }

      await this.ApiService.saveLgpd({ usu_id: this.usu_id });
      this.showModalLgpd = false;
      this.gotoVideo();
    },

    /**
     * Função para redefinir a senha do usuário.
    */
    async actNewPsw () {
      this.msgErro = null
      if (!this.validateNewPassword()) {
        this.msgErro = 'Senha inválida.';
        return
      }
      const payload = {
        usu_id: this.usu_id,
        newPassword: this.newPassword,
      }
      await this.ApiService.resetNewPassword(payload)
      this.showModalResetPassword = false
    },

    /**
     * Altera o estado para mostrar a sala de vídeo e iniciar a sala após um atraso.
     */
    async gotoVideo() {
      if (!this.permissionCamera) {
        alert(`Para continuar com a teleconsulta, é necessário permitir o uso da câmera.` + this.helperMessage('câmera'))
        return
      }
      
      if (!this.permissionMicrophone) {
        alert('Para continuar com a teleconsulta, é necessário permitir o uso do microfone.' + this.helperMessage('Microfone'))
        return
      }

      await this.FirebaseService.authenticateWithCustonToken(this.firebaseToken)

      this.$router.push({path: '/webview/sala', query:{
        cpf: this.inputCpf,
        nome: this.pacNome
      }});
    },

    /**
     * Verifica se a permissão de acesso à câmera está habilitada
     * e lida com erros de permissão ou ausência de câmera.
     * @async
     */
    async checkMediaPermissionsCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        console.log("Câmera está habilitada.");
        this.permissionCamera = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        this.permissionCamera = false
        if (error.name === "NotAllowedError") {
          console.log("Acesso à câmera foi negado.");
          alert(`Para continuar com a teleconsulta, é necessário permitir o uso da câmera.` + this.helperMessage('Câmera'))
        } else if (error.name === "NotFoundError") {
          console.log("Câmera não encontrada.");
          alert("Nenhuma câmera encontrada.");
        } else {
          console.log("Erro ao acessar a câmera: ", error);
          alert("Erro ao acessar a câmera.");
        }
      }
    },

    /**
     * Verifica se a permissão de acesso ao microfone está habilitada
     * e lida com erros de permissão ou ausência de microfone.
     * @async
     */
    async checkMediaPermissionsMicrophone() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        console.log("Microfone está habilitado.");
        this.permissionMicrophone = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        this.permissionMicrophone = false
        if (error.name === "NotAllowedError") {
          console.log("Acesso à microfone foi negado.");
          alert("Permita o acesso ao microfone para continuar."+ this.helperMessage('Microfone'));
        } else if (error.name === "NotFoundError") {
          console.log("Microfone não encontrado.");
          alert("Nenhuma microfone encontrado.");
        } else {
          console.log("Erro ao acessar o microfone: ", error);
          alert("Erro ao acessar o microfone.");
        }
      }
    },

    /**
     * Verifica as informações do navegador atual e exibe um alerta se for o Google Chrome
     * com versão inferior a 125.
     */
    getBrowserInfo() {
      const ua = navigator.userAgent;
      this.browserName = "Desconhecido";
      let version = "Desconhecida";
      let isChrome = false;
      let isFirefox = false;
      // Verificar se é o Google Chrome
      if (/Chrome/i.test(ua)) {
        this.browserName = "Google Chrome";
        isChrome = true;
      }
      // Verificar se é o Mozilla Firefox
      else if (/Firefox/i.test(ua)) {
        this.browserName = "Mozilla Firefox";
        isFirefox = true;
      }
      // Verificar se é o Safari
      else if (/Safari/i.test(ua)) {
        this.browserName = "Safari";
      }
      // Extrair a versão do navegador
      const matchVersion = ua.match(/(Chrome|Firefox|Safari)\/([\d.]+)/);
      if (matchVersion && matchVersion.length === 3) {
        version = matchVersion[2];
      }
      this.browserVersion = version;

      console.log('version', version)
      console.log('browserName', this.browserName)

      this.isWrongBrowser = false;
      if (isChrome && parseFloat(version) < 125) {
        this.isWrongBrowser = true;
        return
      }
      
      if (isFirefox) {
        this.isWrongBrowser = true;
        return;
      }
    },

    /**
     * Valida a senha fornecida, verificando se ela possui:
     * - Pelo menos 8 caracteres;
     * - Pelo menos 1 número;
     * - Pelo menos 1 letra maiúscula;
     * - Pelo menos 1 letra minúscula;
     * - Pelo menos 1 caractere especial.
     * @returns {boolean} Retorna true se a senha for válida, caso contrário, false.
     */
    validateNewPassword() {
      if (!this.newPassword) {
        return false;
      }
      // Regex para validar a senha
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      return passwordRegex.test(this.newPassword);
    },

    /**
     * Verifica se uma senha atende aos critérios de segurança.
     * @param {string} password - A senha a ser verificada.
     */
    validateCheckPassword(password) {
      if (!password) {
        this.checkPsw = {
          caracter: false,
          min: false,
          special: false,
          num: false,
          max: false,
        };
        return;
      }
      this.checkPsw = {
        caracter: password.length >= 8,
        min: /[a-z]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        num: /\d/.test(password),
        max: /[A-Z]/.test(password),
      };
    },

  },
};
</script>
